import React, { useState } from 'react';
import './ProductCard.css';

const ProductCard = ({ product, onProductClick }) => {
    const [imgError, setImgError] = useState(false);

    const title = product?.name || 'Без названия';
    const price = product?.price || 0;
    const images = product?.images || [];
    const colorName = product?.color_name || '';
    const colorCode = product?.color_code || '#c11313';
    const available = Number(product?.total_quantity || 0);
    const stockLabel = available > 0 ? 'В наличии' : 'Нет в наличии';

    const formatPrice = (value) => {
        return new Intl.NumberFormat('ru-RU').format(value) + ' ₽';
    };

    return (
        <article className="product-card" style={{ '--product-accent': colorCode }}>
            <button
                type="button"
                className="product-card-shell"
                onClick={() => onProductClick(product)}
                aria-label={`${title}, ${colorName || 'цвет не указан'}, ${formatPrice(price)}, ${stockLabel}. Открыть товар`}
            >
                <div className="product-card-image">
                    {!imgError && images.length > 0 ? (
                        <img
                            src={images[0]}
                            alt={`${title}, цвет ${colorName || 'не указан'}`}
                            loading="lazy"
                            decoding="async"
                            onError={() => setImgError(true)}
                        />
                    ) : (
                        <div className="product-card-image-placeholder" aria-hidden="true">
                            <span>{title.charAt(0).toUpperCase()}</span>
                        </div>
                    )}
                    <span className={`product-card-status ${available === 0 ? 'sold-out' : ''}`}>
                        {stockLabel}
                    </span>
                </div>
                <div className="product-card-info">
                    <div className="product-card-heading">
                        <div>
                            <p className="product-card-type">{product.category === 'tshirt' ? 'Футболка' : 'Лонгслив'}</p>
                            <h3 className="product-card-title">{title}</h3>
                        </div>
                        <div className="product-card-price">{formatPrice(price)}</div>
                    </div>
                    <div className="product-card-footer">
                        {colorName && (
                            <div className="product-card-color">
                                <i style={{ backgroundColor: colorCode }} aria-hidden="true" />
                                <span>{colorName}</span>
                            </div>
                        )}
                        <span className={`product-card-cta ${available === 0 ? 'disabled' : ''}`}>
                            {available > 0 ? 'Выбрать размер' : 'Посмотреть вещь'}
                        </span>
                    </div>
                </div>
            </button>
        </article>
    );
};

export default ProductCard;
